export const OldHistory = {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  navigate: (_: any) => {},
  location: {},
};
